/**
 * Product Finder Quiz
 * Guides customers through sport → category → gender → skill level
 * then recommends a matching collection.
 */
(function () {
  const quiz = document.getElementById('ProductQuiz');
  if (!quiz) return;

  const state = { step: 0, answers: {} };
  const steps = quiz.querySelectorAll('.quiz-step');
  const progressSteps = quiz.querySelectorAll('.quiz-progress__step');
  const result = quiz.querySelector('.quiz-result');

  /* Collection map: sport > category > gender > skill → collection handle */
  const collections = {
    tennis: {
      racquets: {
        men: {
          beginner: 'tennis-racquets',
          intermediate: 'tennis-racquets',
          advanced: 'tennis-racquets'
        },
        women: {
          beginner: 'tennis-racquets',
          intermediate: 'tennis-racquets',
          advanced: 'tennis-racquets'
        },
        kids: {
          _default: 'tennis-racquets'
        }
      },
      shoes: {
        men: { _default: 'mens-shoes' },
        women: { _default: 'womens-shoes' },
        kids: { _default: 'mens-shoes' }
      },
      apparel: {
        men: { _default: 'mens-apparel' },
        women: { _default: 'womens-apparel' },
        kids: { _default: 'mens-apparel' }
      }
    },
    pickleball: {
      paddles: {
        men: {
          beginner: 'pickleball-paddles',
          intermediate: 'pickleball-paddles',
          advanced: 'pickleball-paddles'
        },
        women: {
          beginner: 'pickleball-paddles',
          intermediate: 'pickleball-paddles',
          advanced: 'pickleball-paddles'
        },
        kids: {
          _default: 'pickleball-paddles'
        }
      },
      shoes: {
        men: { _default: 'mens-shoes' },
        women: { _default: 'womens-shoes' },
        kids: { _default: 'mens-shoes' }
      },
      apparel: {
        men: { _default: 'mens-apparel' },
        women: { _default: 'womens-apparel' },
        kids: { _default: 'mens-apparel' }
      }
    }
  };

  /* Recommendation copy based on answers */
  const recommendations = {
    tennis: {
      racquets: {
        beginner: {
          heading: 'Perfect Racquets for Getting Started',
          text: 'As a beginner, look for racquets with larger head sizes (102-110 sq in) for a bigger sweet spot and more forgiveness. Lighter frames help with maneuverability while you develop your technique.'
        },
        intermediate: {
          heading: 'Level Up Your Game',
          text: 'At the intermediate level, you\'re ready for racquets that offer more control and spin potential. Look for mid-plus head sizes (98-102 sq in) with moderate weight for the perfect blend of power and precision.'
        },
        advanced: {
          heading: 'Pro-Level Performance',
          text: 'Advanced players benefit from heavier, more control-oriented frames. Smaller head sizes (95-100 sq in) give you surgical precision while stiffer frames reward clean ball-striking with explosive power.'
        }
      },
      shoes: {
        _default: {
          heading: 'Court-Ready Footwear',
          text: 'Tennis shoes are designed for the lateral movement, quick stops, and pivots the game demands. Our selection features top brands with durable outsoles, cushioned midsoles, and supportive uppers.'
        }
      },
      apparel: {
        _default: {
          heading: 'Performance Tennis Apparel',
          text: 'Stay cool and comfortable on the court with moisture-wicking fabrics, UV protection, and designs that move with you. From polos to shorts, we\'ve got your court style covered.'
        }
      }
    },
    pickleball: {
      paddles: {
        beginner: {
          heading: 'Paddles for New Players',
          text: 'Starting out in pickleball? Look for paddles with a larger sweet spot, lighter weight (7.0-7.6 oz), and forgiving surfaces. These will help you develop touch and control as you learn the game.'
        },
        intermediate: {
          heading: 'Take Your Pickleball to the Next Level',
          text: 'Ready to improve? Mid-weight paddles (7.6-8.2 oz) with elongated shapes give you more reach and spin potential. Carbon fiber and fiberglass faces offer excellent pop and feedback.'
        },
        advanced: {
          heading: 'Competition-Grade Paddles',
          text: 'For tournament-level play, look for thermoformed paddles with raw carbon faces for maximum spin, edgeless designs for expanded sweet spots, and premium cores for precise shot placement.'
        }
      },
      shoes: {
        _default: {
          heading: 'Court Shoes for Pickleball',
          text: 'Pickleball demands quick lateral movement and solid court grip. Our court shoes feature non-marking outsoles, cushioned support, and lightweight designs perfect for the pickleball court.'
        }
      },
      apparel: {
        _default: {
          heading: 'Pickleball-Ready Apparel',
          text: 'Performance apparel designed for the court — moisture-wicking fabrics, athletic fits, and UV protection to keep you comfortable during long matches and drilling sessions.'
        }
      }
    }
  };

  function showStep(index) {
    steps.forEach(function (s, i) {
      s.classList.toggle('active', i === index);
    });
    progressSteps.forEach(function (s, i) {
      s.classList.toggle('active', i <= index);
    });
    result.classList.remove('active');
    state.step = index;
  }

  function showResult() {
    steps.forEach(function (s) { s.classList.remove('active'); });
    progressSteps.forEach(function (s) { s.classList.add('active'); });

    var sport = state.answers.sport;
    var category = state.answers.category;
    var gender = state.answers.gender;
    var skill = state.answers.skill || null;

    /* Look up collection handle */
    var sportMap = collections[sport];
    var catMap = sportMap ? sportMap[category] : null;
    var genderMap = catMap ? catMap[gender] : null;
    var handle = 'tennis-racquets'; /* fallback */

    if (genderMap) {
      if (skill && genderMap[skill]) {
        handle = genderMap[skill];
      } else if (genderMap._default) {
        handle = genderMap._default;
      }
    }

    /* Look up recommendation copy */
    var sportRec = recommendations[sport];
    var catRec = sportRec ? sportRec[category] : null;
    var rec = null;

    if (catRec) {
      if (skill && catRec[skill]) {
        rec = catRec[skill];
      } else if (catRec._default) {
        rec = catRec._default;
      }
    }

    var heading = rec ? rec.heading : 'Here Are Your Recommendations';
    var text = rec ? rec.text : 'Based on your selections, we think you\'ll love these products.';

    result.querySelector('.quiz-result__heading').textContent = heading;
    result.querySelector('.quiz-result__text').textContent = text;
    result.querySelector('.quiz-result__cta').href = '/collections/' + handle;

    result.classList.add('active');
  }

  /* Event delegation for option clicks */
  quiz.addEventListener('click', function (e) {
    var option = e.target.closest('.quiz-option');
    if (option) {
      var key = option.dataset.key;
      var value = option.dataset.value;
      state.answers[key] = value;

      /* Highlight selection */
      option.closest('.quiz-options').querySelectorAll('.quiz-option').forEach(function (o) {
        o.classList.remove('selected');
      });
      option.classList.add('selected');

      /* Auto-advance after a short delay */
      setTimeout(function () {
        var nextStep = state.step + 1;

        /* Skip skill step for shoes and apparel */
        if (nextStep === 3 && state.answers.category !== 'racquets' && state.answers.category !== 'paddles') {
          showResult();
          return;
        }

        if (nextStep < steps.length) {
          /* Update category label for step 2 if pickleball */
          if (nextStep === 1 && value === 'pickleball') {
            var racquetOption = steps[1].querySelector('[data-value="racquets"]');
            if (racquetOption) {
              racquetOption.dataset.value = 'paddles';
              racquetOption.querySelector('.quiz-option__label').textContent = 'Paddles';
              racquetOption.querySelector('.quiz-option__icon').textContent = '\uD83C\uDFD3';
            }
          } else if (nextStep === 1 && value === 'tennis') {
            var racquetOption2 = steps[1].querySelector('[data-value="paddles"]');
            if (racquetOption2) {
              racquetOption2.dataset.value = 'racquets';
              racquetOption2.querySelector('.quiz-option__label').textContent = 'Racquets';
              racquetOption2.querySelector('.quiz-option__icon').textContent = '\uD83C\uDFBE';
            }
          }

          showStep(nextStep);
        } else {
          showResult();
        }
      }, 300);

      return;
    }

    /* Back button */
    var backBtn = e.target.closest('.quiz-nav__btn--back');
    if (backBtn) {
      if (state.step > 0) {
        showStep(state.step - 1);
      }
      return;
    }

    /* Restart button */
    var restartBtn = e.target.closest('.quiz-result__restart');
    if (restartBtn) {
      state.answers = {};
      quiz.querySelectorAll('.quiz-option').forEach(function (o) {
        o.classList.remove('selected');
      });
      showStep(0);
      return;
    }
  });

  /* Initialize */
  showStep(0);
})();
